var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClinicalNotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 15,
    viewBox: "0 0 12 15",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.17647 4.94118H6C5.41523 4.94118 4.94118 5.41523 4.94118 6V9.17647H0.352941C0.158017 9.17647 0 9.01845 0 8.82353V0.352941C0 0.158017 0.158017 0 0.352941 0H8.82353C9.01845 0 9.17647 0.158017 9.17647 0.352941V4.94118ZM1.94118 2.29412H7.23529C7.43022 2.29412 7.58824 2.1361 7.58824 1.94118C7.58824 1.74625 7.43022 1.58824 7.23529 1.58824H1.94118C1.74625 1.58824 1.58824 1.74625 1.58824 1.94118C1.58824 2.1361 1.74625 2.29412 1.94118 2.29412ZM1.94118 4.05882H5.29412C5.48904 4.05882 5.64706 3.90081 5.64706 3.70588C5.64706 3.51096 5.48904 3.35294 5.29412 3.35294H1.94118C1.74625 3.35294 1.58824 3.51096 1.58824 3.70588C1.58824 3.90081 1.74625 4.05882 1.94118 4.05882ZM5.64706 9.17647V6C5.64706 5.80508 5.80508 5.64706 6 5.64706H9.17647V5.98025C9.18241 6.07396 9.15117 6.17149 9.0731 6.24957L6.24957 9.0731C6.17149 9.15117 6.07396 9.18241 5.98025 9.17647H5.64706ZM9.88235 2.82353H11.6471C11.842 2.82353 12 2.98155 12 3.17647V11.6471C12 11.842 11.842 12 11.6471 12H3.17647C2.98155 12 2.82353 11.842 2.82353 11.6471V9.88235H6C6.28082 9.88235 6.55013 9.7708 6.7487 9.57223L9.57223 6.7487C9.7708 6.55013 9.88235 6.28082 9.88235 6V2.82353Z",
    fill: "#5571C6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClinicalNotes);
export default __webpack_public_path__ + "static/media/clinical_notes.c3e5bf70c8c1397c3f4431427395c1da.svg";
export { ForwardRef as ReactComponent };